<template>
  <div class="eventPostbackReport">
    <div class="title">
      <h2>Event Postback Report</h2>
    </div>
    <div class="bgf0">
      <el-row type="flex">
        <el-col :span="24" style="padding:16px;">
          <el-card shadow="hover" class="pad30">
            <el-form v-model="eventPostbackReport" :inline="true" label-width="100px">
              <el-row>
                <el-col :lg="8" :md="20">
                  <label class="labelName">TranscationId(s)</label>
                  <el-form-item>
                    <el-input
                      v-model="eventPostbackReport.transactionIds"
                      placeholder="transactionIds eg:123 or 123,456"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="20">
                  <label class="labelName">OfferId(s)</label>
                  <el-form-item>
                    <el-input
                      v-model="eventPostbackReport.offerIds"
                      placeholder="offerIds: eg. 2206264 or 2206264,1567396"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="20">
                  <label class="labelName">EventName(s)</label>
                  <el-form-item>
                    <el-input
                      v-model="eventPostbackReport.eventNames"
                      placeholder="eventNames eg:123 or 123,456"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :lg="12" :md="20">
                  <label class="labelName" style="margin-right:20px;">Affiliate(s)</label>
                  <el-form-item>
                    <group-select
                      v-model="eventPostbackReport.affiliateIds"
                      :data-source="affiliatesGroupList"
                      multiple
                      reserve-keyword
                      :loading="affiliateLoading"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width:104%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="12" :md="20">
                  <label class="labelName">Source(s)</label>
                  <el-form-item>
                    <group-select
                      v-model="eventPostbackReport.sourceIds"
                      :data-source="sourcesList"
                      multiple
                      :loading="sourceLoading"
                      clearable
                      filterable
                      placeholder="请选择"
                      style="width:92%;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <label class="labelName" style="margin-right:20px;">TimeZone</label>
                <el-form-item>
                  <el-select v-model="eventPostbackReport.timezone" style="width:420px;">
                    <el-option
                      v-for="item in timezoneOption"
                      :key="item.value"
                      :value="item.number"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <label class="labelName" style="margin-right:60px;">Date</label>
                <el-form-item>
                  <el-date-picker
                    v-model="startToEndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    style="width:260px;"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :lg="3" :md="20" :offset="1">
                  <el-form-item>
                    <el-button type="primary" @click="searchListClick(1)">Search</el-button>
                  </el-form-item>
                </el-col>
                <el-col :lg="6" :md="20">
                  <el-form-item>
                    <el-button type="primary" @click="exportExcelFileClick"
                      >Download Excel</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
          <el-card shadow="hover">
            <el-table
              v-loading="listLoading"
              style="width:100%;"
              height="70vmin"
              stripe
              border
              :data="eventPostbackReportList"
              highlight-current-row
            >
              <el-table-column
                label="No"
                prop="no"
                width="60"
                align="center"
                :fixed="fullWidth <= 768 ? false : 'left'"
              >
              </el-table-column>
              <el-table-column
                label="Transaction Id"
                prop="transactionId"
                min-width="120"
                align="center"
                :fixed="fullWidth <= 768 ? false : 'left'"
                show-overflow-tooltip
                :resizable="false"
              ></el-table-column>
              <el-table-column
                label="aff clickid"
                prop="affClickId"
                min-width="120"
                align="center"
                :fixed="fullWidth <= 768 ? false : 'left'"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="sourceId"
                prop="sourceId"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="Source"
                prop="sourceName"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="affiliateId"
                prop="affiliateId"
                min-width="120"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="affiliate"
                prop="affiliateName"
                min-width="120"
                align="center"
              >
              </el-table-column>
              <el-table-column
                label="offer id"
                prop="offerId"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="offer name"
                prop="offerName"
                min-width="120"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="Prod"
                prop="prod"
                min-width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                label="originalUrl"
                prop="originalUrl"
                min-width="200"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="redirectUrl"
                prop="redirectUrl"
                min-width="200"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="Event Name"
                prop="eventName"
                min-width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="affiliateSub"
                prop="affiliateSub"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="gaid"
                prop="gaid"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="idfa"
                prop="idfa"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="trackCountry"
                prop="trackCountry"
                min-width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="issue status"
                prop="issueStatus"
                min-width="100"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="conversion time"
                prop="conversionTime"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="click time"
                prop="clickTime"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="create time"
                prop="createTime"
                min-width="170"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <pagination
              class="block pagePanel"
              :pageTotal="total"
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              :pageSize="pageSize"
              :currentPage="currentPage"
            ></pagination>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import { api, getEventPostbackReport } from 'api/report';
  import Pagination from '@/components/pagination';
  import GroupSelect from '@/components/GroupSelect';

  import dateUtils from '@/utils/dateutils.js';
  import { myMixin } from '@/mixins/mixins.js';
  import optionData from '@/assets/js/optionData';
  import { mapState, mapActions } from 'vuex';
  import { filterObject } from 'utils/utils';
  import qs from 'querystring';

  export default {
    mixins: [myMixin],
    components: {
      Pagination,
      GroupSelect,
    },
    data() {
      return {
        listLoading: false,
        pageSize: 20,
        currentPage: 1,
        fullWidth: document.documentElement.clientWidth,
        total: null,
        eventPostbackReportList: [],
        startToEndDate: '',
        timezoneOption: optionData.timezoneOption,
        eventPostbackReport: {
          sourceIds: null,
          affiliateIds: null,
          offerIds: null,
          transactionIds: null,
          fromDate: null,
          toDate: null,
          timezone: 0,
        },
        sourceIdArray: [],
      };
    },
    computed: {
      ...mapState('affiliate', {
        affiliatesGroupList: (state) => state.affiliatesGroupList,
        affiliateLoading: (state) => state.affiliateLoading,
      }),
      ...mapState('source', {
        sourcesList: (state) => state.sourcesList,
        sourceLoading: (state) => state.sourceLoading,
      }),
    },
    mounted() {
      //默认选择
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() + 3600 * 1000 * 24);
      this.startToEndDate = [];
      this.startToEndDate[0] = dateUtils.date2StrYMD(end);
      this.startToEndDate[1] = dateUtils.date2StrYMD(start);

      this.getAffiliateList();
      this.getSourceIdsList();
    },
    methods: {
      ...mapActions('affiliate', ['getAffiliateList']),
      ...mapActions('source', ['getSourceIdsList']),
      searchListClick(curPage) {
        if (curPage) {
          this.currentPage = curPage;
        }
        let param = {
          ...this.eventPostbackReport,
          page: this.currentPage,
          pageSize: this.pageSize,
        };
        if (Array.isArray(param.affiliateIds)) {
          param.affiliateIds = param.affiliateIds.join(',');
        }
        if (Array.isArray(param.sourceIds)) {
          param.sourceIds = param.sourceIds.join(',');
        }
        if (Array.isArray(this.startToEndDate) && this.startToEndDate.length === 2) {
          param['fromDate'] = this.startToEndDate[0];
          param['toDate'] = this.startToEndDate[1];
        }
        param = filterObject(param);
        this.listLoading = true;

        getEventPostbackReport(param).then((response) => {
          this.listLoading = false;
          if (response.code === 200) {
            this.eventPostbackReportList = response.result;
            this.total = response.total;
          } else {
            this.$message.error(response.message);
          }
        });
      },
      exportExcelFileClick() {
        let param = {
          ...this.eventPostbackReport,
        };
        if (Array.isArray(param.affiliateIds)) {
          param.affiliateIds = param.affiliateIds.join(',');
        }
        if (Array.isArray(param.sourceIds)) {
          param.sourceIds = param.sourceIds.join(',');
        }
        if (Array.isArray(this.startToEndDate) && this.startToEndDate.length === 2) {
          param['fromDate'] = this.startToEndDate[0];
          param['toDate'] = this.startToEndDate[1];
        }
        param = filterObject(param);
        let strParam = qs.stringify(param);
        window.open(`${api.DOWNLOAD_EVENT_POSTBACK_REPORT}?${strParam}`, '_blank');
      },
      handleSizeChange(size) {
        this.pageSize = size;
        this.handleCurrentChange(1);
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.searchListClick();
      },
      dateChange(time) {
        const date = new Date(time),
          Y = date.getFullYear() + '-',
          M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-',
          D = date.getDate() + ' ';
        return Y + M + D;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
<style lang="scss"></style>
